import { Box, LinearProgress, Typography } from '@mui/material';
import { colors, typography as typographyTokens } from '@components/design-system';

export const TotalCuts = ({
    totalCuts,
    numCutType,
    color,
}: {
    totalCuts: number;
    numCutType: number;
    color: 'success' | 'error';
}) => {
    const percentage = totalCuts === 0 ? 0 : (numCutType / totalCuts) * 100;
    const textColor = color === 'success' ? colors.success.dark : colors.error.dark;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
            <LinearProgress
                variant='determinate'
                value={percentage}
                color={color}
                sx={{
                    flex: 1,
                    height: 6,
                    borderRadius: 3,
                    backgroundColor: colors.neutral[200],
                    '& .MuiLinearProgress-bar': {
                        borderRadius: 3,
                    },
                }}
            />
            <Typography
                sx={{
                    fontSize: typographyTokens.fontSize.sm,
                    fontWeight: typographyTokens.fontWeight.medium,
                    color: textColor,
                    minWidth: 28,
                    textAlign: 'right',
                }}>
                {numCutType}
            </Typography>
        </Box>
    );
};
